import { InputText } from 'primereact/inputtext';
import { Controller } from 'react-hook-form';

import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';

function PersonalSubjectNoField({
  label,
  maxLength,
  disabled,
}: {
  label: string;
  maxLength?: number;
  disabled?: boolean;
}) {
  return (
    <FieldWithErrors name="maticen_broj" label={label}>
      <Controller
        name="maticen_broj"
        render={({ field }) => (
          <InputText
            id="maticen_broj"
            name="maticen_broj"
            value={field.value}
            onChange={(e) => field.onChange(e.target.value.replace(/\D/g, ''))}
            data-cy="ssn"
            maxLength={maxLength}
            disabled={disabled}
          />
        )}
      />
    </FieldWithErrors>
  );
}

export default PersonalSubjectNoField;
